module.exports = __webpack_public_path__ + "img/生态环境部环境与经济政策研究中心.f099668b.png";